<div class="tracking-page-configuration-container">
  <div class="grid-container">
    <!--    LEFT SIDE-->
    <div>
      <pdq-card variant="popover" color="white">
        <form [formGroup]="formGroup">
          <div class="card" [formGroupName]="'settings'">
            <div class="header-container">
              <pdq-heading element="h5">Settings</pdq-heading>
              <pdq-button
                [style.color]="'var(--on-surface-light)'"
                [active]="previewState === 'settingPage'"
                variant="secondary"
                size="medium"
                label="Preview"
                secondaryIcon="side_right_arrow"
                (onClick)="previewSettingsClicked($event)">
              </pdq-button>
            </div>
            <pdq-divider></pdq-divider>
            <div class="card__content">
              <pdq-input
                label="Internal name (only visible to you)"
                formControlName="internalName"
                placeholder="Tracking page">
              </pdq-input>
              <pdq-input-color
                label="Accent color"
                [formControl]="formGroup?.get('settings.accentColor')"
                [control]="formGroup?.get('settings.accentColor')"
                [disabled]="isGrayscale">
              </pdq-input-color>
              <pdq-radio-group label="Color Scheme" formControlName="colorScheme">
                <pdq-radio-button value="semantic" text="Semantic Colors"> </pdq-radio-button>
                <pdq-radio-button value="grayscale" text="Grayscale"> </pdq-radio-button>
              </pdq-radio-group>
              <pdq-input
                label="Tracking page link"
                formControlName="url"
                placeholder="Tracking page link..."
                [tooltip]="'The URL of the theme page which hosts the PDQ App Block'"
                [invalid]="formGroup?.get('settings.url')?.hasError('required')"
                [invalidMsg]="'Required'">
              </pdq-input>

              <pdq-checkbox
                label="Show delivery map"
                labelSize="small"
                formControlName="showDestinationMap"></pdq-checkbox>

              <pdq-input
                label="Stalled shipment time (hours)"
                formControlName="stalledShipmentHours"
                placeholder="120"
                [tooltip]="'Mark a shipment as stalled if no updates for X hours'">
              </pdq-input>
            </div>
          </div>
        </form>
      </pdq-card>

      <tracking-page-simple-tracker
        [formGroup]="formGroup"
        [unsuccessfulTrackingStatusColorPreviewButtonState]="unsuccessfulTrackingStatusColorPreviewButtonState"
        (previewUnsuccessfulTrackingColorClicked)="previewUnsuccessfulTrackingStatusColorClicked($event)">
      </tracking-page-simple-tracker>

      <tracking-page-tracking-details [formGroup]="formGroup" [shop]="shop"> </tracking-page-tracking-details>

      <tracking-page-delivery-promise [formGroup]="formGroup"></tracking-page-delivery-promise>

      <tracking-page-product-widget [formGroup]="formGroup" [shop]="shop"></tracking-page-product-widget>

      <tracking-page-coupon-widget
        [formGroup]="formGroup"
        [shop]="shop"
        (onPreviewChange)="setCouponCodeIndexToPreview($event)"
        [loadedValues]="trackingPageConfiguration?.widgets?.couponCodes"></tracking-page-coupon-widget>

      <tracking-page-integrations-widget [formGroup]="formGroup"></tracking-page-integrations-widget>

      <pdq-divider variant="dashed"></pdq-divider>

      <tracking-page-search-widget
        [formGroup]="formGroup"
        [shop]="shop"
        (onSearchPagePreviewChange)="setTrackingSearchPagePreviewSelected($event)"
        [loadedValues]="trackingPageConfiguration?.settings?.searchPage"
        [previewButtonState]="previewState === 'searchPage'"></tracking-page-search-widget>
    </div>

    <!--    RIGHT SIDE-->
    <div>
      @if (previewState === 'searchPage') {
        <tracking-page-search-preview [shop]="shop" [formGroup]="formGroup"></tracking-page-search-preview>
      }

      @if (previewState === 'settingPage') {
        <tracking-page-preview
          [couponCodeIndexToPreview]="couponCodeIndexToPreview"
          [unsuccessfulTrackingStatusColorPreviewButtonState]="unsuccessfulTrackingStatusColorPreviewButtonState"
          [shop]="shop"
          [formGroup]="formGroup"></tracking-page-preview>
      }

      <pdq-card variant="popover" color="white">
        <div class="card">
          <div class="card__header">
            <pdq-heading element="h5">Install widget</pdq-heading>
          </div>
          <pdq-divider></pdq-divider>
          <div class="card__content">
            <pdq-heading element="h6">Theme block</pdq-heading>
            <div style="font-size: 14px">
              To install this widget via a theme block, add our "Tracking page" app block
              <pdq-link
                label="theme editor"
                [url]="currentThemeEditorUrl"
                style="display: inline-block"
                [external]="true"></pdq-link
              >, then drag and drop it in a new blank page.
            </div>
            <pdq-link
              label="Detailed instructions"
              [url]="'https://support.prettydamnquick.com/en/articles/9155551-setting-up-an-order-tracking-page'"
              [external]="true"></pdq-link>
          </div>
        </div>
      </pdq-card>
    </div>
  </div>
</div>
